// Maybe break this into smaller files but for now it's small enough

import z from "zod";
import { EligibilityToken, Name } from "../login";
import { MemberSourceId } from "../member.firestore";
import { Membership, TrackedMembershipTierId } from "../membership.firestore";
import type { MentionStatus } from "../mention";
import { AgentId, Email, PhoneNumber, TrimmedString } from "../primitives";

export const SortOrderDto = z.enum(["asc", "desc"]);
export type SortOrderDto = z.infer<typeof SortOrderDto>;

export type SortDto<SortFieldType extends string> = {
    by: SortFieldType;
    order: SortOrderDto;
};

export type PaginationDto = {
    from: number;
    size: number;
};
export type PaginatedResult<T> = {
    items: T[];
    total: number;
};

export function createPaginatedResult<T>(
    items: T[],
    total: number,
): PaginatedResult<T> {
    return { items, total };
}

export const VisibilityFilter = z.enum(["published", "unpublished"]);
export type VisibilityFilter = z.infer<typeof VisibilityFilter>;

export const VisibilityFilterTextMap: Record<VisibilityFilter, string> = {
    published: "Published",
    unpublished: "Unpublished",
};

export const TasksSortFields = z.enum([
    "mentionCreatedAt",
    "ticketNumber",
    "mentionDueDate",
]);
export type TasksSortFields = z.infer<typeof TasksSortFields>;

export type TasksQueryFilterDto = {
    searchTerm?: string | undefined;
    mentionStatus?: MentionStatus[] | undefined;
    assignedToAgentIds?: string[] | undefined;
    sort: SortDto<TasksSortFields>;
    pagination?: PaginationDto | undefined;
};

export type TasksSearchResultDto = {
    total: number;
    tasks: TaskDto[];
};

export type TaskDto = {
    id: string;
    memberId: string;
    requestId: string | null;
    mentionCreatedBy: string;
    mentionCreatedAt: string;
    mentionDueDate: string | null;
    mentionResolvedBy: string | null;
    mentionResolvedAt: string | null;
    mentionedAgentIds: string[];
    mentionStatus: MentionStatus;
    requestTicketNumber: number | null;
    message: string;
    memberName: string;
    requestTitle: string | null;
};

export type OverdueRequestsCountDto = {
    overdue: number;
    dueInTheNextHour: number;
};

export type DueTasksDto = {
    dueNow: TaskDto[];
    dueInExactly30Minutes: TaskDto[];
    dueInExactly60Minutes: TaskDto[];
};

export const ServiceLanguageDtoSchema = z.enum(["en", "fr", "de"]);
export type ServiceLanguageDto = z.infer<typeof ServiceLanguageDtoSchema>;

export const AgentCreateMemberRequestDtoSchema = z.object({
    title: TrimmedString.optional(),
    firstName: Name,
    lastName: Name,
    email: Email,
    phoneNumber: PhoneNumber,
    membership: Membership,
    serviceLanguage: ServiceLanguageDtoSchema.optional(),
    assignedAgentId: AgentId,
    source: MemberSourceId.optional(),
    additionalNoteOnSource: z.string().optional(),
});
export type AgentCreateMemberRequestDto = z.infer<
    typeof AgentCreateMemberRequestDtoSchema
>;

export type IdDto = {
    id: string;
};

export const UpdateAgentPermissionGroupDtoSchema = z.object({
    permissionGroup: z.string().min(1),
});
export type UpdateAgentPermissionGroupDto = z.infer<
    typeof UpdateAgentPermissionGroupDtoSchema
>;

export const UpdateAgentProfileDtoSchema = z.object({
    slackId: TrimmedString.nullable().optional(),
    onboardingCallReservationUrl: z.url().nullable().optional(),
    avatarFullPath: z.string().nullable().optional(),
    avatarThumbnailPath: z.string().nullable().optional(),
});
export type UpdateAgentProfileDto = z.infer<typeof UpdateAgentProfileDtoSchema>;
